import { render, staticRenderFns } from "./ships-confirm-auto.vue?vue&type=template&id=0fd8d1e6&scoped=true&"
import script from "./ships-confirm-auto.vue?vue&type=script&lang=js&"
export * from "./ships-confirm-auto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd8d1e6",
  null
  
)

export default component.exports